import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import InventarioManoObraGrid from './InventarioManoObraGrid.jsx';
import InventarioManoObraAbm from './InventarioManoObraAbm.jsx';

/**
 * VEC-3432 — Catálogo de Mano de Obra del módulo de Inventario y Control de Stock v3.0.
 *
 * Entrada de menú hermana del Catálogo de Ítems (VEC-3312), con permisos propios
 * (INVENTARIO_MANO_OBRA_*) y endpoints propios (/inventario/mano-obra). Comparten el flag
 * inventarioItems.habilitado —el módulo de Inventario es uno solo— y la tabla `items`,
 * discriminada por `items.tipo`. No comparten componentes.
 */
const InventarioManoObra = ({ match }) => {
  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage
              id="inventarioManoObra.header_catalogo_de_mano_de_obra"
              defaultMessage="Mano de Obra"
            />
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          <Route exact path={`${match.url}`} render={(props) => <InventarioManoObraGrid {...props} />} />
          <Route exact path={`${match.url}/add`} render={(props) => <InventarioManoObraAbm {...props} action="ADD" />} />
          <Route exact path={`${match.url}/:id`} render={(props) => <InventarioManoObraAbm {...props} action="VIEW" />} />
          <Route exact path={`${match.url}/:id/edit`} render={(props) => <InventarioManoObraAbm {...props} action="EDIT" />} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(InventarioManoObra);
